// Copyright (c) 2019 Deere & Company

import './index.scss';
import LabeledInput from '../../../shared/components/labeled-input';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import React from 'react';

const handleNameChange = props => event => {

    props.onTextChange( event );

};

const handleDropDownChange = props => event => {

    props.componentDropDowninfo( event );

};

const FunctionCodePanel = props => (
    <section className="main-panel">
        <section className="input-panel">
            <div className="sub-div">
                <OptionsDropDown
                    className="componentfactoryText"
                    label="Component Factory"
                    isPlaceholderTranslated={true}
                    onChange={handleDropDownChange( props )}
                    optionDisplayAttributes={['factoryDescription']}
                    optionKey="factoryCode"
                    options={props.componentDropdownList}
                    placeholder=""
                    selectedValue={props.componentFunctionCodeSearch.componentfactoryText}
                    isRequired={true}
                />
            </div>
            <div className="sub-div">
                <LabeledInput
                    className="componentPartNoText"
                    name="componentPartNoText"
                    isEditable={true}
                    disabled={props.componentFunctionCodeSearch.componentfactoryText === -1 || props.componentFunctionCodeSearch.componentfactoryText === '-1'}
                    label="Component Part No"
                    maxLength={12}
                    onChange={handleNameChange( props )}
                    value={props.componentFunctionCodeSearch.componentPartNoText}
                />
            </div>
            <div className="sub-div">
                <LabeledInput
                    className="manufacturingFactText"
                    name="manufacturingFactText"
                    isEditable={true}
                    disabled={props.componentFunctionCodeSearch.componentfactoryText === -1 || props.componentFunctionCodeSearch.componentfactoryText === '-1'}
                    label="Manufacturing Factory"
                    maxLength={2}
                    onChange={handleNameChange( props )}
                    value={props.componentFunctionCodeSearch.manufacturingFactText}
                />
            </div>
            <div className="sub-div">
                <LabeledInput
                    className="modalCodeText"
                    name="modalCodeText"
                    isEditable={true}
                    disabled={props.componentFunctionCodeSearch.componentfactoryText === -1 || props.componentFunctionCodeSearch.componentfactoryText === '-1'}
                    label="Model Code"
                    maxLength={5}
                    onChange={handleNameChange( props )}
                    value={props.componentFunctionCodeSearch.modalCodeText}
                />
            </div>
            <div className="sub-div">
                <LabeledInput
                    className="componentFuncCodeText"
                    name="componentFuncCodeText"
                    isEditable={true}
                    disabled={props.componentFunctionCodeSearch.componentfactoryText === -1 || props.componentFunctionCodeSearch.componentfactoryText === '-1'}
                    label="Component Function Code"
                    maxLength={7}
                    onChange={handleNameChange( props )}
                    value={props.componentFunctionCodeSearch.componentFuncCodeText}
                />
            </div>
            <button type="button" onClick={props.handleAddClick.bind( this )}>
                <span> Add New </span>
            </button>
            <button className="primary-button" type="button" onClick={props.handleSearchClick.bind( this )} disabled={!( props.componentFunctionCodeSearch.componentfactoryText !== -1 && props.componentFunctionCodeSearch.componentfactoryText !== '-1' )}>
                <span> Search </span>
            </button>
        </section>
    </section>
);
FunctionCodePanel.displayName = 'FunctionCodePanel';
FunctionCodePanel.propTypes = {
    componentDropdownList: PropTypes.array.isRequired,
    componentFunctionCodeSearch: PropTypes.object.isRequired,
    handleSearchClick: PropTypes.func,
    handleAddClick: PropTypes.func,
    onTextChange: PropTypes.func,
    componentDropDowninfo: PropTypes.func,
};
export default FunctionCodePanel;
